import request from './http';

export const getList1 = (params) => request({
  url: '/jetlinks/geo/object/device/_search/geo.json',
  method: 'POST',
  data: params
});

// export const getList = (params) => request({
//   url: '/jetlinks/geo/object/device/_search/geo.json',
//   method: 'POST',
//   data: params
// });

export const getList = (options = {}) => request({
  ...options,
  url: '/jetlinks/area/_query/no-paging',
  method: 'GET'
});
